import { Candidate, CandidateServerData, CopyCandidateRequest } from '~/definitions/candidates';
import BaseAPIClient from '~/clientUtils/baseApiClient';

class CandidateApi extends BaseAPIClient {
    constructor() {
        super('', {});
    }

    async getCandidateList(regionId: string): Promise<CandidateServerData[]> {
        return this.request({
            method: 'GET',
            url: `/api/getCandidateList/${regionId}`,
        });
    }

    async deleteCandidate(candidateId: string): Promise<void> {
        return this.request({
            method: 'DELETE',
            url: `/api/candidate/${candidateId}`,
        });
    }

    async uploadCandidatePhoto(candidateId: string, file: File): Promise<any> {
        const formData = new FormData();
        formData.append('file', file);
        return this.request({
            method: 'POST',
            url: `/api/candidate/${candidateId}/media`,
            data: formData,
        });
    }

    async createCandidate(data: Candidate, regionId: string): Promise<string> {
        return this.request({
            method: 'POST',
            url: `/api/candidate`,
            data: {
                data,
                regionId,
            },
        });
    }

    async updateCandidate(candidateId: string, data: Candidate): Promise<string> {
        return this.request({
            method: 'PUT',
            url: `/api/candidate/${candidateId}`,
            data: {
                data,
            },
        });
    }

    async getCandidateAttributeOptions(attributeNumbers: string[]): Promise<any> {
        return this.request({
            method: 'POST',
            url: `/api/candidate/attributeOptions`,
            data: {
                attributeNumbers,
            },
        });
    }

    async copyCandidate(params: CopyCandidateRequest): Promise<any> {
        return this.request({
            method: 'POST',
            url: `/api/candidate/copy`,
            data: params,
        });
    }

    async unlinkCandidateFromRegion(id: string, candidateId: string): Promise<void> {
        return this.request({
            method: 'DELETE',
            url: `/api/region/${id}/candidate/${candidateId}`,
        });
    }

    async unlinkMedia(candidateId: string, assetId: string): Promise<void> {
        return this.request({
            method: 'DELETE',
            url: `/api/candidate/${candidateId}/media`,
            data: {
                assetId,
            },
        });
    }
}

const candidateApi = new CandidateApi();

export default candidateApi;
